<template>
  <div
    class="heart-container d-flex align-center"
    :itemprop="includeProps ? 'reviewRating' : null"
    :itemscope="includeProps"
    :itemtype="includeProps ? 'https://schema.org/Rating' : null"
    @mouseleave="onMouseLeave"
  >
    <meta v-if="includeProps" itemprop="worstRating" content="1" />
    <meta v-if="includeProps" itemprop="ratingValue" :content="rating" />
    <meta v-if="includeProps" itemprop="bestRating" content="5" />
    <span
      class="d-flex"
      :class="{ 'cursor-pointer': reactive }"
      v-for="(icon, index) in 5"
      :key="icon.hash"
      @mouseenter="onMouseEnter(index)"
      @click="onClick(index)"
    >
      <SvgWrapper
        :use="getIcon(index).icon"
        :class="getIcon(index).colorClass"
        :dimensions="dimensions"
      />
    </span>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const ICON = {
  HEART_FULL: 'icon_svg_heart_full',
  HEART_EMPTY: 'icon_svg_heart_empty',
  HEART_QUARTER: 'icon_svg_heart_1_4',
  HEART_HALF: 'icon_svg_heart_1_2',
  HEART_THREE_QUARTERS: 'icon_svg_heart_3_4'
}

export default {
  emits: ['ratingChanged'],
  components: { SvgWrapper },
  props: {
    rating: [String, Number],
    dimensions: {
      type: String,
      default: '19'
    },
    reactive: {
      type: Boolean,
      default: false
    },
    includeProps: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      givenRating: 0,
      showRating: 0
    }
  },
  created() {
    this.givenRating = this.rating
    this.showRating = this.rating
  },
  methods: {
    getIcon(index) {
      let remainder = this.showRating - index
      if (remainder >= 0.75) {
        return {
          icon: 'icon_svg_heart_filled',
          colorClass: 'filled'
        }
      } else if (remainder > 0.5) {
        return { icon: ICON.HEART_THREE_QUARTERS }
      } else if (remainder > 0.25) {
        return { icon: ICON.HEART_HALF }
      } else if (remainder > 0) {
        return { icon: ICON.HEART_QUARTER }
      } else {
        return {
          icon: 'icon_svg_heart_filled',
          colorClass: 'empty'
        }
      }
    },
    onMouseEnter(index) {
      if (!this.reactive) return
      this.showRating = index + 1
    },
    onMouseLeave() {
      if (!this.reactive) return
      this.showRating = this.givenRating
    },
    onClick() {
      if (!this.reactive) return
      if (this.givenRating === this.showRating) {
        this.givenRating = 0
      } else {
        this.givenRating = this.showRating
      }
      this.$emit('ratingChanged', this.givenRating)
    }
  }
}
</script>
<style scoped>
span:not(:first-of-type) {
  display: flex;
  margin-left: 2px;
}

.filled {
  fill: rgb(var(--v-theme-primary));
}

.empty {
  fill: rgb(var(--v-theme-beige));
}
</style>
